import React from "react";
import isElectron from "../Utils/isElectron";
import { useWebAppUpdate } from "../Hooks/useWebAppUpdate";
import "./AppUpdateBanner.css";

const AppUpdateBanner = () => {
  const {
    updateAvailable,
    isApplying,
    isPwa,
    currentVersion,
    remoteVersion,
    applyUpdate,
    dismissUpdate,
  } = useWebAppUpdate();

  if (isElectron() || !updateAvailable) {
    return null;
  }

  const label = remoteVersion && remoteVersion !== currentVersion
    ? `Version ${remoteVersion} is ready`
    : "A new version is ready";

  const subtitle = isPwa
    ? {
        full: "Tap Update to reload the installed app with the latest fixes.",
        short: "Reload to get the latest version.",
      }
    : currentVersion
      ? {
          full: `You are on ${currentVersion}.`,
          short: `Current: ${currentVersion}`,
        }
      : null;

  return (
    <div
      className={`app-update-banner${isPwa ? " app-update-banner--pwa" : ""}`}
      role="alertdialog"
      aria-live="polite"
    >
      <div className="app-update-banner__content">
        <div className="app-update-banner__text">
          <span className="app-update-banner__message">{label}</span>
          {subtitle ? (
            <>
              <span className="app-update-banner__sub app-update-banner__sub--desktop">
                {subtitle.full}
              </span>
              <span className="app-update-banner__sub app-update-banner__sub--mobile">
                {subtitle.short}
              </span>
            </>
          ) : null}
        </div>
        <div className="app-update-banner__actions">
          {!isPwa ? (
            <button
              type="button"
              className="app-update-banner__btn app-update-banner__btn--secondary"
              onClick={dismissUpdate}
              disabled={isApplying}
            >
              Later
            </button>
          ) : null}
          <button
            type="button"
            className="app-update-banner__btn app-update-banner__btn--primary"
            onClick={applyUpdate}
            disabled={isApplying}
          >
            {isApplying ? "Updating…" : isPwa ? "Update" : "Reload"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppUpdateBanner;
